import React from "react";
import { AiFillFire } from "react-icons/ai";
import { IoClose } from "react-icons/io5";
import PkgAmenitiesService from "../../../services/PkgAmenitiesService";
import { AmenityResType } from "./TabAddPkgAmenites";
type PropsType = {
  prevAddedAmenities: AmenityResType[];
  fetchPkgAmenities: () => void;
};
export const ViewPkgAmenities = (props: PropsType) => {
  const handleDeleteAmenity = async (item: AmenityResType) => {
    try {
      await PkgAmenitiesService.deleteAmenity(item.id);
      props.fetchPkgAmenities();
    } catch (error) {
      console.log(error);
    }
  };
  const handleUpdatePkgAmenity = async (
    item: AmenityResType,
    isHighlightEmenity: boolean
  ) => {
    try {
      const itemtobeupdatd = item;
      itemtobeupdatd.isHighlightEmenity = isHighlightEmenity;
      const res = await PkgAmenitiesService.updateAmenity(
        itemtobeupdatd.id,
        itemtobeupdatd
      );
      props.fetchPkgAmenities();
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <h2 className="font-bold mb-3">Previous Amenities</h2>
      <div className="grid grid-cols-3 gap-4">
        {props.prevAddedAmenities?.map((item: AmenityResType, i) => (
          <div
            key={i}
            className="bg-gray-100 px-2 py-1 flex space-x-2 items-center cursor-pointer w-fit"
          >
            {item.isHighlightEmenity === false ? (
              <span
                className="text-gray-400"
                onClick={() => handleUpdatePkgAmenity(item, true)}
              >
                <AiFillFire title="Select this as highlighted amenity" />
              </span>
            ) : (
              <span
                className="text-orange-600"
                onClick={() => handleUpdatePkgAmenity(item, false)}
              >
                <AiFillFire title="Deselect this from highlighted amenity" />
              </span>
            )}
            <span>
              <img
                src={`${process.env.REACT_APP_API}/uploads/images/${item.amenity_icon}`}
                alt=""
                className="h-8 w-8 object-contain mr-2"
              />
            </span>
            {item?.amenity}{" "}
            <IoClose
              onClick={(e) => handleDeleteAmenity(item)}
              className="cursor-pointer"
              title="Deselect item!"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
